import { ChakraStylesConfig } from 'chakra-react-select';

export const getSelectStyles = (
  dropdownValueColor: string,
  dropdownIndicatorColor: string,
  selectedItemBackgroundColor: string,
  selectedItemTextColor: string,
  hoverBackgroundColor: string,
  activeDropdownValueColor: string
) => {
  const chakraStyles: ChakraStylesConfig = {
    control: (provided, state) => {
      return {
        ...provided,
        borderRadius: 'base',
        minHeight: 6,
        maxHeight: 78,
        overflowY: 'auto',
        height: state.isMulti ? 'auto' : 6,
        cursor: 'pointer',
      };
    },
    valueContainer: (provided) => {
      return {
        ...provided,
        paddingLeft: 2,
        fontSize: 'xs',
        marginTop: -0.5,
        paddingRight: 0,
      };
    },
    input: (provided) => {
      return {
        ...provided,
        color: dropdownValueColor,
      };
    },
    multiValue: (provided) => {
      return {
        ...provided,
        fontSize: 'xs',
        paddingTop: 0.5,
        paddingBottom: 0,
        minHeight: 0,
        maxWidth: 200,
        minWidth: 'fit-content',
      };
    },
    multiValueRemove: (provided) => {
      return {
        ...provided,
        paddingY: 0,
      };
    },
    clearIndicator: (provided) => {
      return {
        ...provided,
        padding: 0,
        width: 4,
        height: 4,
        fontSize: '0.5rem',
        colorScheme: 'gray',
      };
    },
    dropdownIndicator: (provided) => {
      return {
        ...provided,
        marginX: 0,
        padding: 0,
        paddingBottom: 1,
        color: dropdownIndicatorColor,
        marginTop: '2px',
      };
    },
    noOptionsMessage: (provided) => {
      return {
        ...provided,
        fontSize: 'xs',
      };
    },
    menuList: (provided) => {
      return {
        ...provided,
        borderRadius: 'md',
        padding: 1,
      };
    },
    menu: (provided) => {
      return {
        ...provided,
        minWidth: 200,
      };
    },
    option: (provided, state) => {
      return {
        ...provided,
        fontSize: 'xs',
        borderRadius: 'lg',
        paddingY: 0,
        paddingLeft: 2,
        minHeight: 7,
        fontWeight: state.isSelected ? 'bold' : 'normal',
        color: state.isSelected ? selectedItemTextColor : undefined,
        backgroundColor: state.isSelected
          ? selectedItemBackgroundColor
          : undefined,
        _hover: {
          color: state.isSelected ? selectedItemTextColor : undefined,
          backgroundColor: state.isSelected
            ? selectedItemBackgroundColor
            : hoverBackgroundColor,
        },
      };
    },
  };

  const activeSelectChakraStyles: ChakraStylesConfig = {
    ...chakraStyles,
    valueContainer: (provided) => {
      return {
        ...provided,
        paddingLeft: 2,
        fontSize: 'xs',
        marginTop: -0.5,
        color: activeDropdownValueColor,
        paddingRight: 0,
      };
    },
  };

  return {
    chakraStyles,
    activeSelectChakraStyles,
  };
};
